import { optionTitle_accessibility } from './AccessibilityOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AccessibilityOption: LazyOption = createLazyOption(
    {
        key: 'accessibilityOption',
        titleStringKey: optionTitle_accessibility,
        searchTermsStringKey: optionTitle_accessibility,
        isHidden: () => isConsumer(),
    },
    lazyFullModule,
    m => m.default
);
export default AccessibilityOption;
